import React from 'react'

import { PlayStepsPanelWrapper } from 'components/Owner/Plays/card-style'
import PlayStepProgressStepper from 'components/Owner/Plays/PlayStepProgressStepper'

const PlayStepsPanel = ({
  steps,
  setUpStepId,
  disabled = false,
  changeSetUpStepHandler,
  currentActiveStep,
}) => {
  return (
    <PlayStepsPanelWrapper>
      <h6>Steps</h6>
      <PlayStepProgressStepper
        disabled={disabled}
        steps={steps}
        setUpStepId={setUpStepId}
        currentActiveStep={currentActiveStep}
        changeSetUpStepHandler={changeSetUpStepHandler}
      />
    </PlayStepsPanelWrapper>
  )
}

export default PlayStepsPanel
